import preAssessmentNurseTranslations from '../data/preAssessmentNurseTranslations.json' with { type: 'json' };
import { firstSentencePreview } from './journeyPresentation.js';
import { getRoleVariant } from './roleFamilies.js';
import { canDisplayLocalizedRoleVariant, getLocalizedSurgeonVariant } from '../data/roleFamilyTranslations.js';
import { journeySurgicalSpecialistMachineTitle } from '../data/journeySurgicalSpecialistMachineTitles.js';

const isVisibleText = value => typeof value === 'string' && value.trim()
  && !/^(?:roles:)?items\.[a-z0-9_]+\.[\w.]+$/i.test(value.trim());

const langCode = value => String(value || 'en').trim().toLowerCase().split('-')[0];

// Journey cards must not assume a role returned by fetchJobRoles() is already
// localized. Resolve the SELECTED language's published runtime text directly;
// prefer a professional override, otherwise the existing machine-only bundle.
// Never turn a requested specialty variant into its generic parent title.
export function journeyRoleCardCopy(role, selectedLanguage, getResource) {
  const language = langCode(selectedLanguage);
  const key = role?.role_key || role?.roleKey || role?.id;
  const english = language === 'en';
  const variant = role?.variantKey && role.variantKey !== key;
  const familyVariant = variant ? getRoleVariant(role.variantKey) : null;
  const midwifeVariant = familyVariant?.parentRoleKey === 'midwife' && canDisplayLocalizedRoleVariant(familyVariant, language)
    ? getLocalizedSurgeonVariant(familyVariant, language)
    : null;
  const lookup = (ns, path) =>
    typeof getResource === 'function' ? getResource(language, ns, path) : undefined;
  const roleTitle = lookup('roles', 'items.' + key + '.title');
  const roleDescription = lookup('roles', 'items.' + key + '.description');
  const guideSummary = lookup('patientGuides', 'items.' + key + '.summary');
  const supplement = key === 'pre_assessment_nurse'
    ? preAssessmentNurseTranslations.translations?.[language]
    : null;
  const variantTitle = variant ? lookup('roles', 'items.' + role.variantKey + '.title') : null;
  const machineVariantTitle = variant ? journeySurgicalSpecialistMachineTitle(language, role.variantKey) : '';
  const title = english ? role?.title
    : variant
      ? (isVisibleText(variantTitle) ? variantTitle : midwifeVariant?.title || machineVariantTitle || role?.title)
      : (isVisibleText(roleTitle) ? roleTitle
        : isVisibleText(supplement?.title) ? supplement.title : role?.title);
  const description = midwifeVariant?.summary || (english ? role?.description
    : (isVisibleText(roleDescription) ? roleDescription
      : isVisibleText(supplement?.description) ? supplement.description
      : isVisibleText(guideSummary) ? guideSummary : ''));
  return {
    title: title || '',
    // A translated guide summary is a legitimate fallback when a legacy
    // 'roles' description is missing; never show the English description
    // underneath a translated title.
    description: firstSentencePreview(description),
    language,
    titleTranslated: english || (variant
      ? Boolean(isVisibleText(variantTitle) || midwifeVariant?.title || isVisibleText(machineVariantTitle))
      : Boolean(isVisibleText(roleTitle) || isVisibleText(supplement?.title))),
    descriptionTranslated: english || Boolean(midwifeVariant?.summary || isVisibleText(roleDescription)
      || isVisibleText(supplement?.description) || isVisibleText(guideSummary)),
  };
}
